interface ShortListedPropertyCardProps {
  className?: string;
  subAssetType?: string;
  subAssetTypeBgcolor?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  propertyLink?: string;
  propertyDateType?: string;
}
export const ShortListedPropertyCard = ({
  className,
  subAssetType,
  subAssetTypeBgcolor,
  price,
  address,
  imageLink,
  propertyLink,
  propertyDateType,
}: ShortListedPropertyCardProps) => {
  return (
    <a
      className={`flex bg-brand-lightBlue py-4 pl-3 mid:pl-4 items-center shadow-md   max-h-[112px] hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out ${className}`}
      href={propertyLink}
    >
      <div className="clip-path-bottomRightPropertyImage relative">
        <img
          className="h-[60px] w-[120px] mid:w-[161px] mid:h-[80px]"
          src={imageLink}
          alt=""
        />
        <div
          className={`absolute top-0 h-[18px] w-[96px]  mid:h-[23px] mid:w-[127px] ${subAssetTypeBgcolor}  clip-path-subAssetText`}
        >
          <p className="font-openSans w-max pl-1 capitalize font-semibold text-web-body-sm leading-[20px] text-brand-textBlack tracking-widest">
            {subAssetType}
          </p>
        </div>
      </div>

      <div className="mx-auto  mid:pb-3">
        <p className="font-openSans font-semibold text-web-subheading mid:text-[24px] leading-6 mid:leading-8 text-brand-textBlack">
          {propertyDateType === "undated" ? "Contact Us" : `₹ ${price}`}
        </p>
        <p className="font-openSans capitalize mt-1 mid:mt-[6px]  font-normal text-web-body-sm mid:text-web-body-md leading-6 text-brand-textGrey">
          {address}
        </p>
      </div>
    </a>
  );
};
